// File: src/components/Answer/AnswerError.tsx

import React from "react";
import styles from "./Answer.module.css";
import { AnswerIcon } from "./AnswerIcon";

interface Props {
    error: string;
    onRetry: () => void;
}

export const AnswerError: React.FC<Props> = ({ error, onRetry }) => {
    const normalizedError = (error || "").trim();
    const normalizedLower = normalizedError.toLowerCase();
    const isNetworkError =
        normalizedError.includes("Failed to fetch") ||
        normalizedError.includes("NetworkError") ||
        normalizedError.includes("Load failed") ||
        normalizedError.includes("Network error: the backend is not reachable");
    const isContentSafetyError =
        normalizedLower.includes("azure content safety") ||
        normalizedLower.includes("content filter") ||
        normalizedLower.includes("guardrail");

    return (
        <div className={styles.answerContainer}>
            <AnswerIcon />
            <div className={styles.answerContent}>
                <div className={styles.answerText}>
                    <p style={{ color: "#ef4444" }}>
                        {isContentSafetyError
                            ? "Content blocked by safety policy"
                            : isNetworkError
                              ? "Network Access Required"
                              : "Something went wrong. Please try again."}
                    </p>
                    {isContentSafetyError && (
                        <>
                            <p style={{ fontSize: "13px", color: "#9ca3af", marginTop: "8px" }}>
                                This request was blocked by Azure guardrails before the assistant could answer.
                            </p>
                            <ul style={{ marginTop: "8px", paddingLeft: "18px", color: "#9ca3af", fontSize: "13px" }}>
                                <li>sexual content</li>
                                <li>violence</li>
                                <li>self-harm</li>
                                <li>hate or abusive content</li>
                            </ul>
                        </>
                    )}
                    {isNetworkError && (
                        <>
                            <p style={{ fontSize: "13px", color: "#9ca3af", marginTop: "8px" }}>
                                The backend is not reachable. This app is accessible only through the internal network or VPN.
                            </p>
                            <ul style={{ marginTop: "8px", paddingLeft: "18px", color: "#9ca3af", fontSize: "13px" }}>
                                <li>backend/gateway unreachable</li>
                                <li>network restriction/firewall</li>
                                <li>no internal network/VPN route</li>
                            </ul>
                        </>
                    )}
                    <p style={{ fontSize: "13px", color: "#9ca3af", marginTop: "8px" }}>{error}</p>
                    <button
                        onClick={onRetry}
                        style={{
                            marginTop: "12px",
                            padding: "6px 12px",
                            background: "transparent",
                            border: "1px solid #565869",
                            borderRadius: "6px",
                            color: "#9ca3af",
                            cursor: "pointer",
                            fontSize: "13px",
                            transition: "all 0.2s ease"
                        }}
                        onMouseOver={e => {
                            e.currentTarget.style.borderColor = "#ea580c";
                            e.currentTarget.style.color = "#ea580c";
                        }}
                        onMouseOut={e => {
                            e.currentTarget.style.borderColor = "#565869";
                            e.currentTarget.style.color = "#9ca3af";
                        }}
                    >
                        Try again
                    </button>
                </div>
            </div>
        </div>
    );
};
